import axios from "axios";

const api_login = axios.create({
  //baseURL: "http://10.203.0.16:3001",
  baseURL: "https://api.arenafitness.codx.dev.br",
});

export default api_login;
